<template>
  <div>
    <el-dialog title="修改标签"
               :visible.sync="dialogVisible"
               v-dialogDrag
               :close-on-click-modal="false"
               :append-to-body="true"
               width="500px"
               :before-close="handleClose">

      <el-row :gutter="10">
        <el-col :span="3"
                style="line-height:36px;font-size:15px">新标签:</el-col>
        <el-col :span="18">
          <el-input clearable
                    placeholder="请输入"
                    v-model="form.favorite_tags"></el-input>
        </el-col>
      </el-row>
      <span slot="footer"
            class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary"
                   @click="save">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data () {
    return {
      dialogVisible: false,
      form: {},
    }
  },
  methods: {
    handleClose () {
      this.dialogVisible = false
    },
    save () {
      this.$http({
        url: '/api/v1/favorites/favorite_edit',
        method: 'post',
        data: {
          id: this.form.question_favorite_id,
          tags: this.form.favorite_tags
        }
      }).then(res => {
        this.$notify({
          title: '提示',
          message: '修改成功!',
          type: 'success'
        });
        this.$parent.refresh()
        this.handleClose()
      })
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
  font-size: 20px;
  font-weight: bold;
  color: black;
  text-align: center;
}

::v-deep .el-dialog__headerbtn .el-dialog__close {
  color: white;
  background: #cccccc;
  border-radius: 50%;
  padding: 4px;
}
</style>